<template>
    <DataTransfersContainer
        :project="selectedProject"
        :month="selectedMonth"
    ></DataTransfersContainer>
</template>

<script>
import store from '@/store'
import DataTransfersContainer from '@/modules/DataTransfers'
import DataTransfersStore from '@/modules/DataTransfers/_store'
import { getCurrentInstance } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
const STORE_KEY = '$_dataTransfers'

export default {
    components: {
        DataTransfersContainer
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectGroup,
            selectedGroup,
            selectedProject,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            selectedMonth
        } = useSelectMonth()
        if (!selectedProject.value) {
            setInitialAccountSelect()
        }
        if (selectedGroup.value) {
            selectGroup(null)
        }
        store.dispatch(`${STORE_KEY}/getDataTransfers`, {
            projectIdx: selectedProject.value.projectIdx,
            month: selectedMonth.value
        })
        return {
            selectedProject,
            selectedMonth
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, DataTransfersStore)
        }
        next()
    }
}
</script>

<style>

</style>
